import _ from 'lodash';
import { RootState } from '../store';
import { stat } from 'fs';

export const isLoggedIn = (state: RootState) => state.auth.authenticated;
export const authInitialized = (state: RootState) => state.auth.initialized;
export const sendPasswordResetSuccess = (state: RootState) => state.auth.dialogSuccess;
export const resetPasswordSuccess = (state: RootState) => state.auth.dialogSuccess;
export const updateAccountSuccess = (state: RootState) => state.auth.dialogSuccess;
export const confirmActiveDirectorySuccess = (state: RootState) => state.auth.dialogSuccess;
export const invalidToken = (state: RootState) => state.auth.invalidToken;

export const currentUser = (state: RootState) => state.auth.user;

export const isLoggedInAs = (state: RootState) =>
    state.auth.authenticated !== undefined && state.auth.alias !== undefined;

export const isAdmin = (state: RootState) =>
    state.auth.selfInfo?.admin;

export const hasPrivilege = (state: RootState) => {
    return (privileges: string[]) => {
        if (state.auth.privileges) {
            return _.intersection(
                state.auth.privileges?.own.map((p) => p.name),
                privileges
            ).length > 0;
        } else {
            return false;
        }
    };
};

export const getAssignablePrivileges = (state: RootState) => state.auth.privileges?.assign ?? [];

export const canSeeUsersPage = (state: RootState) => state.auth.privileges?.own.
    find((p) => p.name === 'SUPER_ADMIN' || p.name === 'USER_ADMIN') !== undefined;

export const canSeeApplicationsPage = (state: RootState) => state.auth.privileges?.own
    .find((p) => p.name === 'SUPER_ADMIN' || p.name === 'WORKSPACE_ADMIN') !== undefined;

export const canSeeGroupsPage = (state: RootState) => state.auth.privileges?.own
    .find((p) => p.name === 'SUPER_ADMIN' || p.name === 'WORKSPACE_ADMIN') !== undefined;

export const canSeeWorkspacesPage = (state: RootState) => state.auth.privileges?.own
    .find((p) => p.name === 'SUPER_ADMIN' || p.name === 'WORKSPACE_ADMIN') !== undefined;

export const canSeeServersPage = (state: RootState) => state.auth.privileges?.own
    .find((p) => p.name === 'SUPER_ADMIN' || p.name === 'ADMIN') !== undefined;

export const canEditServersPage = (state: RootState) => state.auth.privileges?.own
    .find((p) => p.name === 'SUPER_ADMIN') !== undefined;

export const canSeeDatabasePage = (state: RootState) => state.auth.privileges?.own
    .find((p) => p.name === 'SUPER_ADMIN') !== undefined;

export const canSeeUpdatePage = (state: RootState) =>
    state.auth.user?.is_old_user !== undefined && state.auth.alias !== undefined;

export const themeBackgroundImage = (state: RootState) => {
    if (state.auth.theme) {
        return process.env.PUBLIC_URL + state.auth.theme.backgroundImage.replace(/^\.+/g, '');
    }
};
export const themeLogoImage = (state: RootState) => {
    if (state.auth.theme) {
        return process.env.PUBLIC_URL + state.auth.theme.logoImage.replace(/^\.+/g, '');
    }
};

export const themeIconImage = (state: RootState) => {
    if (state.auth.theme) {
        return process.env.PUBLIC_URL + state.auth.theme.iconImage.replace(/^\.+/g, '');
    }
};

export const themeOrgName = (state: RootState) => {
    if (state.auth.theme) {
        return  state.auth.theme.organizationName;
    }
};

export const themeFavicon = (state: RootState) => {
    if (state.auth.theme && state.auth.theme.favicon && state.auth.theme.favicon !== '') {
        return (process.env.PUBLIC_URL + "/" + state.auth.theme.favicon.replace(/^\.+/g, '')).replace('//', '/');
    }
};

export const adEnabled = (state: RootState) => {
    if (state.auth.theme) {
        return state.auth.theme.activeDirectory;
    }
};

export const hideGroups = (state: RootState) => {
    if (state.auth.theme) {
        return state.auth.theme.hideGroups;
    }
};

export const about = (state: RootState) => {
    return state.auth.about;
};

export const currentSessions = (state: RootState) => {
    return state.auth.sessions;
};

export const getSelfApplications = (state: RootState) => {
    return state.auth.selfInfo?.applications;
};

export const isOldUser = (state: RootState) => {
    return state.auth.user?.is_old_user;
};
export const ssoEnabled = (state: RootState) => {
    return state.auth.sso ?? false;
};
export const organizationName = (state: RootState) => {
    return state.auth.organizationName ?? "";
};

export const loadingApplication = (state: RootState) => {
    return state.auth.loadingApplication;
};

export const url = (state: RootState) : string => {
    return state.auth.url;
};

export const task = (state: RootState) : string => {
    return state.auth.task;
};

export const application = (state: RootState) : string => {
    return state.auth.application;
}

export const queryString = (state: RootState): string => {
    return state.auth.queryString;
}